import { Divider, Grid, Tooltip } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import styles from "../../../styles/customerStyles.module.css";
import { updateProductStatus } from "../../../../../api/product";
import PlaceholderImage from "../../../assets/placeholder.jpg";
import ProductCard from "./ProductCard";
import ProductCardForDashboard from "../../dashboard/components/ProductCardForDashboard";
import { productSelector } from "../../../../../redux/slices/productSlice";
import { storeSelector } from "../../../../../redux/slices/storeSlice";

const longText = `
We are currently still sourcing this product. Please note that we do not work with any AliExpress sellers. U-Send Fulfillment will source this product straight from the factory. For this reason our sourcing can take up to 48 hours.
`;

const ProductReviewCard = ({ products, title }) => {

  const { isLoading, productInfo, productsByUser } =
    useSelector(productSelector);
  const handleImageError = (event) => {
    event.target.src = PlaceholderImage;
  };

  const location = useLocation().pathname;

  const productsLocation = location === "/customer/dashboard";

  const mappedProducts = productsByUser?.data?.products
    ? productsByUser?.data?.products
    : isLoading || productInfo?.length === 0
    ? [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
    : products;

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);

  const getProductStatusChips = (product) => {
    if (product?.status === "failed") {
      return (
        <Tooltip
          componentsProps={{
            tooltip: {
              sx: {
                backgroundColor: "#ffff",
                maxWidth: "450px",
                width: "auto",
                boxShadow:
                  "rgb(145 158 171 / 20%) 0px 0px 2px 0px, rgb(145 158 171 / 35%) 0px 12px 24px -4px",
                color: "black",
                fontSize: "13px",
                fontWeight: 500,
                padding: "15px",
                textAlign: "left",
              },
            },
            arrow: {
              sx: {
                fontSize: 16,
                color: "#ffff",
              },
            },
          }}
          title={
            <div>
              <h6 style={{ fontSize: "16px", fontWeight: 600 }}>
                This product could not be sourced because...
              </h6>
              <Divider />
              {product?.unquotation_reasons?.selected_reasons?.map(
                (reason, i) => (
                  <p style={{ fontWeight: 500 }}>
                    <strong>{i + 1}. </strong>
                    {reason}
                  </p>
                )
              )}

              {product?.unquotation_reasons?.other_reasons !== "" && (
                <>
                  <h6 style={{ fontSize: "14px", fontWeight: 600 }}>
                    *Other Reasons
                  </h6>
                  <h6 style={{ lineHeight: 1.5 }}>
                    {product?.unquotation_reasons?.other_reasons}
                  </h6>
                </>
              )}
            </div>
          }
          placement="top"
          arrow
        >
          <div
            style={{
              background: "#FFCFCF",
              width: "100%",
            }}
            className={styles.fulfillment}
          >
            Failed
          </div>
        </Tooltip>
      );
    } else {
      return (
        <Tooltip
          componentsProps={{
            tooltip: {
              sx: {
                backgroundColor: "#ffff",
                maxWidth: "210px",
                boxShadow:
                  "rgb(145 158 171 / 20%) 0px 0px 2px 0px, rgb(145 158 171 / 35%) 0px 12px 24px -4px",
                color: "black",
                fontSize: "13px",
                fontWeight: 500,
                padding: "15px",
                textAlign: "left",
              },
            },
            arrow: {
              sx: {
                fontSize: 16,
                color: "#ffff",
              },
            },
          }}
          title={longText}
          placement="top"
          arrow
        >
          <div
            style={{
              background: "rgba(102, 155, 244, 0.29)",
              width: "100%",
              fontSize: "12px",
              cursor: "pointer",
              // margin: "auto",
            }}
            // onClick={handleOpen}
            className={styles.fulfillment}
          >
            Pending
          </div>
        </Tooltip>
      );
    }
  };
  return (
    <div style={{ paddingRight: !productsLocation ? "30px" : "30px" }}>
      <Grid
        container
        spacing={!productsLocation ? 3 : 1}
        sx={{ marginTop: "10px" }}
      >
        {mappedProducts?.map((product) => (
          <Grid
            key={product._id}
            item
            xl={!productsLocation ? 2 : 6}
            lg={!productsLocation ? 3 : 6}
            md={!productsLocation ? 4 : 6}
            sm={!productsLocation ? 4 : 6}
            xs={12}
          >
            {product?.status !== "failed" && product?.status !== "pending" ? (
              <div>
                {!productsLocation ? (
                  <ProductCard
                    product={product}
                    handleImageError={handleImageError}
                    title={title}
                    getProductStatusChips={getProductStatusChips}
                  />
                ) : (
                  <ProductCardForDashboard
                    product={product}
                    handleImageError={handleImageError}
                    title={title}
                    getProductStatusChips={getProductStatusChips}
                  />
                )}
              </div>
            ) : !productsLocation ? (
              <ProductCard
                open={open}
                setOpen={setOpen}
                product={product}
                longText={longText}
                handleOpen={handleOpen}
                handleImageError={handleImageError}
                title={title}
                getProductStatusChips={getProductStatusChips}
              />
            ) : (
              <ProductCardForDashboard
                product={product}
                handleImageError={handleImageError}
                title={title}
                getProductStatusChips={getProductStatusChips}
              />
            )}
          </Grid>
        ))}
      </Grid>
      {/* )} */}
    </div>
  );
};

export default ProductReviewCard;
